import { action, makeObservable } from 'mobx';
import {ContentLookup, X1Language, X2AgeCategory, X3Level} from '../../../domain';
import {Control, newValueForSelection, validators} from '../../../lib/helpers';

export class SelectLevelStore {
  language: Control<X1Language | null>;
  ageCategory: Control<X2AgeCategory | null>;
  level: Control<X3Level | null>;

  readonly languageOptions: readonly X1Language[];
  ageCategoryOptions: readonly X2AgeCategory[];
  levelOptions: readonly X3Level[];

  constructor(readonly lookup: ContentLookup) {
    makeObservable(this);
    this.languageOptions = lookup.Languages;
    this.ageCategoryOptions = [];
    this.levelOptions = [];

    this.language = new Control<X1Language | null>(
      'language', null, validators.required
    );
    this.ageCategory = new Control<X2AgeCategory | null>(
      'ageCategory', null, validators.required
    );
    this.level = new Control<X3Level | null>(
      'level', null, validators.required
    );

    this.language.addValueChangeListener((language) => {
      this.ageCategoryOptions = [];
      if (language !== null)
        this.ageCategoryOptions = language.AgeCategories!;
      const newValue = newValueForSelection(this.ageCategoryOptions, this.ageCategory.value);
      this.ageCategory.setValue(newValue);
    });

    this.ageCategory.addValueChangeListener((ageCategory) => {
      this.levelOptions = [];
      if (ageCategory !== null)
        this.levelOptions = ageCategory.Levels!;
      const newValue = newValueForSelection(this.levelOptions, this.level.value);
      this.level.setValue(newValue);
    });
  }

  @action
  setLevel = (level: X3Level | null) => {
    if (level === null) {
      return;
    }

    const levelId = level.Id;
    level = this.lookup.X3LevelById[levelId];
    if (level === undefined)
      return;
    this.language.setValue(level.AgeCategory!.Language);
    this.ageCategory.setValue(level.AgeCategory!);
    this.level.setValue(level);
  };
}
